import Image from "next/image";

const WebinarInviteLink = () => {
	const subject = "Zaproszenie na webinar: Przyjazne Deklaracje";

	const body = `Witaj,
Przyjazne Deklaracje zapraszają na webinar z którego dowiesz się o najnowszych możliwościach tego rozwiązania.
Możesz zarejestrować się pod linkiem:
https://przyjazne-deklaracje.pl/webinar`;

	const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
		body,
	)}`;

	return (
		<div className="copy-message text-right">
			<a href={mailtoLink}>
				<Image
					src="https://przyjazne-deklaracje.pl/resources/images/icons/general/files/icon-copy.svg"
					alt="Ikona koperty"
					width={18}
					height={20}
					style={{ marginRight: "8px", verticalAlign: "middle" }}
				/>
				Kopiuj treść wiadomości
			</a>
		</div>
	);
};

export default WebinarInviteLink;
